import React from 'react';
import { Badge, Box, CircularProgress } from '@mui/material';
import useTranslate from '../../../customHooks/useTranslate';
import IconButton from '../../../muiComponents/IconButton';
import Tooltip from '../../../muiComponents/Tooltip';

interface ActivityButtonProps {
    unresolvedCount: number;
    hasActiveProcesses?: boolean;
    open: boolean;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const maxVisibleNotifications = 99;

/**
 * Displays the activity button, notification badge and process indicator.
 * @param props The notification count, process state and popover controls.
 * @returns The activity button and its process indicator.
 */
const ActivityButton = ({
    unresolvedCount,
    hasActiveProcesses = false,
    open,
    onClick,
}: ActivityButtonProps) => {
    const translate = useTranslate();

    return (
        <Box className='activity__button'>
            <Tooltip titleText='activity'>
                <Badge
                    badgeContent={unresolvedCount}
                    color='primary'
                    max={maxVisibleNotifications}
                    overlap='circular'
                >
                    <IconButton
                        id='activity-button'
                        iconName='NotificationsNoneOutlined'
                        aria-label={translate('activity')}
                        aria-haspopup='dialog'
                        aria-expanded={open}
                        aria-controls={open ? 'activity-popover' : undefined}
                        aria-busy={hasActiveProcesses}
                        size='small'
                        onClick={onClick}
                    />
                </Badge>
            </Tooltip>
            {hasActiveProcesses && (
                <CircularProgress
                    size={40}
                    aria-hidden='true'
                    className='activity__indicator'
                />
            )}
        </Box>
    );
};

export default ActivityButton;
